//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VideoContainer from '@/components/VideoContainer'
import FileContainer from '@/components/FileContainer'
export default {
  name: "ManufacturerPostDialog",
  components: {
    VideoContainer,
    FileContainer
  },
  data() {
    return {
      info: {},
      showDialog: false
    }
  },
  methods: {
    show(info) {
      this.info = info
      this.showDialog = true
    }
  }
}
